import { FC, useId } from 'react';

import { Box } from '@bonusly/design-system';

import custom1 from '../../assets/images/post-wrap/custom-1.png';

interface CustomTileWrapProps {
	src?: string;
	tileSize?: number;
}

export const CustomTileWrap: FC<CustomTileWrapProps> = ({ src, tileSize = 75 }) => {
	const uid = useId();
	const patternId = `custom-tile-${uid.replace(/:/g, '')}`;

	if (!src) {
		return (
			<Box
				position="relative"
				w="100%"
				h="100%"
				backgroundImage={`url(${custom1})`}
				backgroundRepeat="no-repeat"
				backgroundSize="cover"
				backgroundPosition="center"
			/>
		);
	}

	const W = tileSize;
	// Pattern cell is 2W×2W — even column has two full rows, odd column has three
	// images staggered by W/2 so the top/bottom edges clip correctly across pattern repeats
	const P = W * 2;

	return (
		<Box position="relative" w="100%" h="100%">
			<svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg">
				<defs>
					<pattern id={patternId} x="0" y="0" width={P} height={P} patternUnits="userSpaceOnUse">
						{/* Even column — two full tiles */}
						<image href={src} x={0} y={0} width={W} height={W} />
						<image href={src} x={0} y={W} width={W} height={W} />
						{/* Odd column — offset by W/2, three images so top/bottom halves fill the boundary */}
						<image href={src} x={W} y={-W / 2} width={W} height={W} />
						<image href={src} x={W} y={W / 2} width={W} height={W} />
						<image href={src} x={W} y={W * 1.5} width={W} height={W} />
					</pattern>
				</defs>
				<rect width="100%" height="100%" fill={`url(#${patternId})`} />
			</svg>
		</Box>
	);
};
